import { z } from 'zod';

import { JourneyNotificationTemplateVariable } from '../../JourneyBuilder/interfaces/JourneyNotification';

import notificationButton from '../../JourneyBuilder/validator/notification-button';
import { DivComponent } from '../utils/htmlComponents';
import { OnsiteVariants } from '../utils/variantConstants';
import { CTAButton, Image, Text } from './components';
import carousel from '../../JourneyBuilder/validator/notification-carousel';
import { journeyNotificationAttachment } from '../../JourneyBuilder/validator/notification-attachment';

export enum TemplateTypes {
  SMS = 'sms',
  EMAIL = 'email',
  WHATSAPP = 'whatsapp',
  WEB_PUSH = 'webpush',
  FCM = 'fcm',
  RCS = 'rcs',
}
export enum TemplateMode {
  PROMOTIONAL = 'promotional',
  TRANSACTIONAL = 'transactional',
}
// if changed change backend too
export enum WhatsappContentType {
  TEXT = 'Text',
  MEDIA = 'Media',
}
export enum WhatsappMediaType {
  IMAGE = 'Image',
  VIDEO = 'Video',
  DOCUMENT = 'Document',
}
export enum BackgroundType {
  COLOR = 'Color',
  IMAGE = 'Image',
}
export interface TemplateVariantData {
  title: Text;
  description?: Text;
  backgroundType: BackgroundType;
  backgroundImage?: Image;
  backgroundColor?: string;
  primaryButton?: CTAButton;
  secondaryButton?: CTAButton;
  removeSecondaryButton?: boolean;
  removeImage?: boolean;
  primaryImage?: Image;
  position?: OnsitePositions;
  removeCloseButton?: boolean;
  closeButtonBackgroundColor: string;
  closeButtonXColor: string;
  autoDismiss: {
    timeInSeconds: number;
  } | null;
  aspectRatio?: string;
  rawHtml?: string;
  variantName?: OnsiteVariants;
}
export interface Template {
  id: number;
  name: string;
  subject?: string;
  template_id?: string;
  content_mode?: TemplateMode;
  channel: TemplateTypes;
  content: string;
  meta?: {
    templateVariables?: JourneyNotificationTemplateVariable[];
    whatsappContentType?: WhatsappContentType;
    whatsappMediaType?: WhatsappMediaType;
    thumbnailUrl?: string;
    html?: string;
    css?: string;
    onsite?: TemplateVariantData;
    carousel?: Carousel;
    buttons?: NotificationButton[];
    attachment?: Attachment | null;
  };
  tags: {
    id?: number;
    subTag: {
      id: number;
      name: string;
    };
  }[];
  provider: string;
}
type Carousel = z.infer<typeof carousel>;
type NotificationButton = z.infer<typeof notificationButton>;
type Attachment = z.infer<typeof journeyNotificationAttachment>;

export enum OnsitePositions {
  MIDDLE_TOP = 'MIDDLE_TOP',
  MIDDLE_BOTTOM = 'MIDDLE_BOTTOM',
  LEFT_BOTTOM = 'LEFT_BOTTOM',
  RIGHT_BOTTOM = 'RIGHT_BOTTOM',
  LEFT_TOP = 'LEFT_TOP',
  RIGHT_TOP = 'RIGHT_TOP',
  MIDDLE_TOP_FULL = 'MIDDLE_TOP_FULL',
  MIDDLE_BOTTOM_FULL = 'MIDDLE_BOTTOM_FULL',
}

export enum BuilderId {
  Description = 'onsite.meta.description',
  Title = 'onsite.meta.title',
  PrimaryButtonLabel = 'onsite.meta.primaryButton.label',
  SecondaryButtonLabel = 'onsite.meta.secondaryButton.label',
  Container = 'container',
  Image = 'image',
  CloseButton = 'onsite.meta.removeCloseButton',
  Div = 'div',
  BackgroundImage = 'onsite.meta.backgroundImage.link',
}

export enum BuilderComponentTitle {
  Description = 'Text',
  Title = 'Heading',
  Button = 'Button',
  Image = 'Image',
  CloseButton = 'Close',
  Container = 'Background',
  Div = 'Box',
}

export const builderIdLabels: Record<BuilderId, BuilderComponentTitle> = {
  [BuilderId.Description]: BuilderComponentTitle.Description,
  [BuilderId.Title]: BuilderComponentTitle.Title,
  [BuilderId.PrimaryButtonLabel]: BuilderComponentTitle.Button,
  [BuilderId.SecondaryButtonLabel]: BuilderComponentTitle.Button,
  [BuilderId.Container]: BuilderComponentTitle.Container,
  [BuilderId.Image]: BuilderComponentTitle.Image,
  [BuilderId.CloseButton]: BuilderComponentTitle.CloseButton,
  [BuilderId.Div]: BuilderComponentTitle.Div,
  [BuilderId.BackgroundImage]: BuilderComponentTitle.Container,
};

export interface VariantConstants {
  variantName: string;
  variantData: TemplateVariantData;
  allowedPositions: OnsitePositions[];
  thumbnail_url?: string;
  variantFunction: (
    variantData: TemplateVariantData,
    width?: string
  ) => DivComponent;
}
